import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';

import { NEW_REQUIREMENT_SELECT_OPTION_CODE } from '../constants/newRequirementSelectOption';
import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertManuallyRequirementsFormValueToKnmData = (
  values: IKnmErknmForm,
): IKnm248['manuallyRequirements'] => {
  const { knoOrganizationErknm, kindControl, requirementsErknm } = values;

  if (!requirementsErknm) {
    return null;
  }
  const requirementsFiltered = requirementsErknm.filter(
    item => (!item.requirement || item.requirement.code === NEW_REQUIREMENT_SELECT_OPTION_CODE) && item.manualTitle,
  );

  return requirementsFiltered.map(item => ({
    uuidOrganization: knoOrganizationErknm?.value.dictVersionId || null,
    uuidSupervision: kindControl?.value.dictVersionId || null,
    value: {
      id: null,
      code: null,
      title: item.manualTitle || null,
      nameNpa: item.manualNameNpa || null,
      numberNpa: convertFormDateValueToKnmDataDate(item.manualDateNpa),
    },
    isObserved: typeof item.isObserved?.value === 'boolean' ? item.isObserved.value : null,
    note: item.note || null,
  }));
};
